import type { ViewerModel } from '@wix/thunderbolt-symbols'

const EDITOR_ELEMENTS_NAMESPACE = 'wixui'

export function getEditorElementsVersion(viewerModel: ViewerModel): string | undefined {
	try {
		const editorElements = (viewerModel?.componentsLibrariesTopology ?? [])
			.filter((library) => library?.namespace === EDITOR_ELEMENTS_NAMESPACE)
			.pop()

		return editorElements?.url.split('/').pop() || undefined
	} catch {
		return undefined
	}
}
